import Big from "big.js";
import uuid from "uuid";
import BaseEntity from "./base.entity";
import { fn } from "util";

export default class Sellable extends BaseEntity {
  defaultParams() {
    return {
      uuid: uuid(),
      unit_label: "UNID",
      category: {},
      category_uuid: null,
      name: "",
      image_url: null,
      code: "",
      restock_count: 0,
      stock_count: 0,
      cost_value: 0,
      sell_value: 0,
      type: "product",
      products_uuids: {},
      taxes: {
        ncm: "",
        csosn: "",
        cfop: "",
        cest: "",
        pis: "",
        cofins: "",
        origin: "",
        gtin: "",
        icms: {
          cst: "",
          cfop: "",
          modBC: "",
          pICMS: "",
          pFCP: "",
          modBCST: "",
          pMVAST: "",
          pRedBCST: "",
          pICMSST: "",
          pFCPST: "",
          pRedBC: "",
          motDesICMS: "",
          pST: "",
          pFCPSTRet: "",
          pRedBCEfet: "",
          pICMSEfet: ""
        },
        pis_normal: {
          cst: "",
          pPIS: "",
          vAliqProd: ""
        },
        cofins_normal: {
          cst: "",
          pCOFINS: "",
          vAliqProd: ""
        },
        use_default_configuration: true
      },
      barcodes: [],
      optional_groups_uuids: [],
      variations_uuids: []
    };
  }

  getServiceObject() {
    if (this.code.length === 0) {
      let name = this.name.replace(/\s+/g, "");
      let first4Letters = name.substring(0, 4).toUpperCase();
      let randomDigits = Math.floor(1000 + Math.random() * 9000);
      this.code = first4Letters + randomDigits;
    }

    const taxes = {};
    [
      "cest",
      "cfop",
      "csosn",
      "ncm",
      "pis",
      "cofins",
      "origin",
      "use_default_configuration",
      "pis_normal",
      "cofins_normal",
      "icms",
      "gtin"
    ].forEach(tax => {
      if (!fn.isBlank(this.taxes[tax])) {
        taxes[tax] = this.taxes[tax];
      }
    });

    return {
      category_uuid: this.category_uuid,
      code: this.code,
      company_uuid: this.company_uuid,
      cost_value: parseInt(this.cost_value, 10),
      deleted: this.deleted,
      image_url: this.image_url !== "" ? this.image_url : null,
      taxes: taxes,
      is_snapshot: this.is_snapshot || false,
      name: this.name,
      optional_groups_uuids: this.optional_groups_uuids,
      product_variations: this.product_variations,
      products_uuids: this.products_uuids,
      stock_count: this.stock_count,
      restock_count: this.restock_count,
      sell_value: parseInt(this.sell_value, 10),
      type: this.type || "product",
      unit_label: (this.unit_label || "").toUpperCase(),
      variations_uuids: this.variations_uuids,
      uuid: this.uuid
    };
  }

  identifier() {
    return this.name || this.code || "Não identificado";
  }

  getStockValue() {
    return Math.max(this.stock_count * this.sell_value, 0);
  }

  setProfit(value) {
    const relativeProfit = Big(value)
      .div(100)
      .plus(1);
    this.sell_value = Big(this.cost_value)
      .times(relativeProfit)
      .toFixed(2);
  }

  getProfit() {
    const costValue = this.getCostValue();
    const sellValue = this.getSellValue();
    const profit = sellValue.minus(costValue);
    if (sellValue.eq(0)) {
      return Big(0);
    }
    return costValue.eq(0) ? Big(100) : profit.div(sellValue).times(100);
  }

  getCostValue() {
    return this.cost_value ? Big(this.cost_value) : Big(0);
  }

  getSellValue() {
    return this.sell_value ? Big(this.sell_value) : Big(0);
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/sellable.entity.js